import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import AUIButton from '@ancert/aui-button';
import AUIIcon from '@ancert/aui-icon';
import { AUITable } from '@ancert/aui-table';
import { useTranslation } from 'react-i18next';
import getColumns from './columns';
import './ModalManuales.scss';

/**
 * Modal para mostrar manueales de ayuda
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal
 * @param {Array} props.documents - Documentos
 * @returns {React.ReactElement} - Componente ModalManuales
 */
const ModalManuales = ({ show, onClose, documents }) => {
  const reloadColumns = () => getColumns(useTranslation().t);
  const { t } = useTranslation();
  const tableColumns = useMemo(reloadColumns, [documents]);
  return (
    <AUIModal
      autoHeight
      closeable
      className="modal"
      title={t('modalAyuda.title')}
      show={show}
      actionButtons={[
        {
          mode: 'tertiary',
          label: t('closeButton'),
          onClick: onClose,
        },
      ]}
      onClose={onClose}
    >
      <p>{t('modalAyuda.guide')}</p>

      {documents.length === 1 ? (
        <div className="document">
          <div className="description">
            <AUIIcon color="red" icon="pdfDuotone" />
            <span>{documents[0].name}</span>
          </div>
          <div className="button">
            <AUIButton
              mode="outline"
              label={t('downloadButton')}
              size="md"
              minWidth={80}
              onClick={() => {
                // Siempre se tiene que abrir en otra pestaña, lo que hace que se descargue automáticamente en móvil
                window.open(documents[0].link, '_blank', 'noopener,noreferrer');
              }}
            />
          </div>
        </div>
      ) : (
        <AUITable data={documents} columns={tableColumns} totalData={documents.length} className="u-mt-24" />
      )}
    </AUIModal>
  );
};

ModalManuales.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  documents: PropTypes.func.isRequired,
};

export default ModalManuales;
